/**
 * 1stdibs
 * User: James
 * Date: 2/19/13
 */


/**
 * Standard extension Backbone.AssociatedModel with functionality
 * to make your life easier working with services. 
 *
 * @class SoaModel
 * @extends Backbone.AssociatedModel
 *
 * @property {string} currentAction
 *      The current action is a public property that is set when
 *      fetch / save / delete is invoked on the model. This is used with the urls map to find the
 *      appropriate endpoint. TEST 1
 * @property {object} urls
 *      In inherited models, this should be a hash map of actions to URLs.
 *      For example, urls['fetch'] = "/path/to/GET/thing".
 * @property {object} transformer
 *      An optional object of mapping you can include in your models to configure
 *      differences between a client side and server side contract. To take advantage
 *      of this, init you instance of SoaModel with an instance of bunsen.contractTransformer.
 *      For example, transformer = new bunsen.contractTransformer(mapOrFunction)
 * @property {boolean} dotNotation
 *      enable dot notation for gets
 * @property {boolean} removeStoreDupes
 *      When you call "set", if you are changing the id of a model, then this property tells
 *      the set method to remove the likely duplicate model from the Backbone.Relational.store
 *      instance.
 */
(function (root, factory) {
    "use strict";
    var _;
    var _exports;
    var Backbone;
    var _module;
    /**
     * Gets called automatically on initialization. We call the parent and then
     * bind an event to 'sync' so that we can save a copy of the last sync attributes
     */
    var constructor = function (attributes, options) {
        var relations = _.result(this, 'relations');
        this.relations = relations;
        Backbone.AssociatedModel.prototype.constructor.call(this, attributes, options);
        this._lastSyncAttrs = this.toJSON();
        this.on('sync', function () {
            this._lastSyncAttrs = this.toJSON();
        });

        // Set the transformer:
        if (options) {
            this.transformer = options.transformer ? options.transformer : null;
        } else {
            this.transformer = null;
        }
    };

    if (typeof module !== 'undefined') {
        Backbone = require('dibs-backbone');
        _ = require('underscore');
        module.exports = _exports = Backbone.AssociatedModel.extend({constructor: constructor});
        // CommonJS
        factory(
            module,
            require('dibs-backbone'), // exports Backbone
            _,
            require('dibs-jquery-shim'),
            require('bunsen/libraries/bunsen')
        );
        _exports = module.exports;
    } else {
        Backbone = root.Backbone;
        _ = root._;
        _exports = Backbone.AssociatedModel.extend({constructor: constructor});
        // Use different var name to prevent hoisting
        _module = { exports: _exports };
        // Browser globals
        factory(_module,
            root.Backbone,
            root._,
            root.$,
            root.bunsen
        );
        _exports = _module.exports;
    }

    root.bunsen = root.bunsen || {};
    root.bunsen.SoaModel = _exports;
}(typeof window === 'undefined' ? global : window, function (module, Backbone, _, $, bunsenLib) {
    "use strict";

    var createRel, omitToJSON;

    //noinspection JSClosureCompilerSyntax

    var SoaModel = module.exports;

    _.extend(SoaModel.prototype, /** @ignore */{
        _lastSyncAttrs: {},

        // The current action is a public property that is set when fetch / save / delete is invoked on the model. This
        // is used with the urls map to find the appropriate endpoint.
        currentAction: 'fetch',

        // In inherited models, this should be a hash map of actions to URLs.
        // For example: "fetch" : "/path/to/GET/thing"
        urls: {},

        /**
         * Instead of specifying one URL property on SOA model, we use a function based on
         * the URLs map to determine the right endpoint
         * @memberOf SoaModel#
         */
        url: function () {
            return this.urls[this.currentAction];
        },

        // An optional object or mapping you can include in your models to configure differences between a client side
        // and server side contract. To take advantage of this, init your instance of SoaModel with an instance of
        // bunsen.contractTransformer, ie. {transformer : new bunsen.contractTransformer(mapOrFunction)}

        transformer : null,

        // Enable dot notation for gets
        dotNotation : true,

        // When you call 'set', if you are changing the id of a model, then this property tells
        // the set method to remove the likely duplicate model from the Backbone.Relational.store instance
        removeStoreDupes : true,

        /**
         * @param {object} [options]
         * @param {string} [actionName] Sets the current action
         * @memberOf SoaModel#
         * @returns {$.Deferred.promise}
         */
        fetch: function (options, actionName) {
            this.currentAction = actionName || 'fetch';
            return SoaModel.__super__.fetch.call(this, options);
        },

        /**
         * @param attributes
         * @param options
         * @param {string} [actionName='save'] - sets the current action
         * @memberOf SoaModel#
         * @returns {$.Deferred.promise}
         */
        save: function (attributes, options, actionName) {
            this.currentAction = actionName || 'save';

            return SoaModel.__super__.save.call(this, attributes, options);
        },
        /**
         * @param {string} method
         *      if not a GET or PATCH, use regular sync, but add the attrs to the
         *      options, which will force this to send the JSON specified
         * @param {Backbone.Model} model
         * @param {object} passedOptions
         * @memberOf SoaModel#
         * @returns {$.Deferred.promise}
         */
        sync : function (method, model, passedOptions) {
            var tokenObj;
            var options = _.extend({}, passedOptions);

            // Add query params to the URL
            if (options.queries) {
                options.url = bunsenLib.extendURL(options.url || _.result(this, 'url'), options.queries);
            }

            // Append the user token to the URL.
            if ((tokenObj = this.getTokenObj())) {
                if (method === 'read') {
                    _.defaults(options, {data: {}});
                    options.data = _.defaults({}, options.data, tokenObj);
                } else {
                    options.url = bunsenLib.extendURL(options.url || _.result(model, 'url'), tokenObj);
                }
            }

            // If custom attributes were not specified and this is a POST or PUT, use omitToJSON
            // to automatically remove attributes that the models specify to not be sent with
            // the 'omitFromSave' and 'saveJSONFields' relation options
            if ((!options || !options.attrs) && (method === 'create' || method === 'update')) {
                if (!options) { options = {}; }
                options.attrs = omitToJSON.call(this, this);
            }

            return SoaModel.__super__.sync.call(this, method, model, options);
        },

        /**
         * @deprecated Just use save and pass queries object
         * @memberOf SoaModel#
         * @returns {$.Deferred.promise}
         */
        saveWithQueryParameters : function (attributes, options, actionName) {
            return this.save(attributes, options, actionName);
        },

        /**
         * Find a parent the first instance matching a constructor
         * @param construct
         * @memberOf SoaModel#
         * @returns {Backbone.AssociatedModel}
         */
        findParent : function (construct) {
            construct = (typeof construct === 'string') ? bunsenLib.getNamespacedValue(construct) : construct;

            // If the parents array is empty, then check for a collection with parents:
            if ((!this.parents.length) && (this.collection) && (this.collection.parents.length)) {
                return _.findWhere(this.collection.parents, { constructor  : construct });

            // Otherwise, check the parents of the model iteself.
            }
            return _.findWhere(this.parents, { constructor  : construct });
        },

        /**
         * If the parents is a single length array, return the instance, otherwise return
         * the array of parents
         * @memberOf SoaModel#
         * @returns {Backbone.AssociatedModel|Backbone.AssociatedModel[]}
         */
        getParent: function () {
            if (this.parents && this.parents.length === 1) {
                return this.parents[0];
            }
            return this.parents;
        },

        /**
         * Same as Backbone.Model.prototype.set, except that if the key has a
         * '.' (dot notation) this will attempt to set the property on a nested
         * submodule where the pattern is '<submodel_name>.<submodel_key>'
         * So for, example item.set('pricing.currency', 'US') would be equivalent
         * to item.get('pricing').set('currency', 'US'). Additionally, a new
         * option for mergeHasOne is allowed, which will set merge a nested
         * object in your value or attributes param with an existing attribute
         * instead of overwriting it.
         * @param {string|object} key
         *      A string key to set or an object map of the attributes to set
         * @param {*} [val]
         * @param {object} [options]
         * @memberOf SoaModel#
         * @returns {SoaModel}
         */
        set: function (key, val, options) {
            var segs, model, opts, obj = {};
            if (typeof key === 'string' && key.indexOf('.') !== -1) {
                segs = key.split('.');
                model = this;

                while (segs.length > 1 && model) {
                    model = model.get(segs.shift());
                }

                model.set(segs.shift(), val, options);

                return this;
            }
            opts = options || ((key && val && typeof key === "object" && typeof val === "object") ? val : {});
            if (typeof key === "object") { obj = key; } else { obj[key] = val; }
            return SoaModel.__super__.set.call(this, obj, opts);
        },
        /**
         * Return a copy of the model attributes at the time of the last
         * 'sync' event. Useful for reverting a model to it's state at the
         * time of the last sync with the api when your application
         * @memberOf SoaModel#
         * @returns {object}
         */
        lastSyncAttributes : function () {
            return this._lastSyncAttrs;
        },

        /**
         * Determine if model has changed since last sync. if attrs is passed,
         * only compare the passed attrs. Return list of changed attrs.
         * @memberOf SoaModel#
         * @param {string[]} [attrs]
         * @return {boolean}
         */
        changedSinceLastSync: function (attrs) {
            var comparingAttrs = attrs || _.keys(this.attributes),
                changed = [],
                self = this;
            _.each(comparingAttrs, function (attr) {
                var modelProperty = self.get(attr);

                if (modelProperty instanceof Backbone.Model) {
                    modelProperty = modelProperty.toJSON();
                }
                if (!_.isEqual(modelProperty, self._lastSyncAttrs[attr])) {
                    changed.push(attr);
                }
            });
            return _.isEmpty(changed) ? false : changed;
        },

        /**
         * Retrieves the token query params
         * object for the current user. If
         * no token object has been set, defers
         * to the bunsen.getToken function.
         * @return {object}
         */
        getTokenObj: function () {
            return this._tokenObject || bunsenLib.getToken();
        },

        /**
         * Sometimes the token needs to be set
         * manually, instead of relying on a 
         * cookie. This can be done with this
         * method.
         * @param {string} token The user's token
         * @param {string} [key=userToken]
         *        The query param name for the token
         * @returns {SoaModel}
         */
        setToken: function (token, key) {
            key = key || 'userToken';
            if (!token) {
                this._tokenObject = null;
                return this;
            }
            this._tokenObject = {};
            this._tokenObject[key] = token;
            return this;
        },

        /**
         * Special parse function for SOA model does 2 things:
         *      1- Retreive the data object from the server response (usually nested under a "result" attribute)
         *      2- Apply an optional mapping to the JSON data.
         *
         * @param data
         * @memberOf SoaModel#
         * @returns {object}
         */
        parse : function (data) {
            var result = {};
            var isServiceWrapper;

            // If the response was empty, return an empty object
            if (_.isEmpty(data)) {
                return {};
            }

            // New style service response uses the result property :
            isServiceWrapper = typeof data.result !== 'undefined' || data.apiType === 'serviceResponse';

            if (isServiceWrapper) {
                result = this._getServiceData(data);

            } else {
                result = this._getLegacyServiceData(data);

                // If we didn't find the result in the location specified by service response, then use the top level
                // object. Takes care of BB Associations parse called on nested models / collections.
                if (_.isEmpty(result)) {
                    return data;
                }
            }

            if (this.transformer) {
                result = this.transformer(result, 'read');
            }

            return result;
        },

        /**
         * Private function to get service response data from the expected location which is the "result" property.
         * @param data
         * @returns {*}
         * @private
         */
        _getServiceData : function (data) {
            var result;

            // Look out for responses nested an extraneous layer, like "dataList"
            if (_.size(data.result) === 1 && !data.result.apiType && _.isObject(data.result[_.keys(data.result)[0]])) {
                result = data.result[_.keys(data.result)[0]];
            } else {
                result = data.result;
            }

            return result || {};
        },

        /**
         * Private function to get service response data from legacy contracts such as the form service or query
         * service. These old services would use the property "form" or "row" for data.
         * @param data
         * @returns {{}}
         * @private
         */
        _getLegacyServiceData : function (data) {
            var rowKey;
            var result = {};

            var keys = (data && typeof data === 'object') ? _.keys(data) : false;

            // If there was a "form" attribute (from the form service) - then use that...
            if (data.form && data.formCode) {
                result = data.form;
            }

            // If the result is under the "row" attribute (query service)
            else if (data.row) {
                if (_.size(data.row) === 1) {
                    result = data.row[_.keys(data.row)[0]];
                } else {
                    result = data.row;
                }
            }

            // If the result object is still empty, attempt to look through the data attributes one by one for the "row"
            // attribute
            if (_.isEmpty(result) && keys) {
                rowKey = keys.shift();
                while (rowKey) {
                    if (data[rowKey] && data[rowKey].row) {
                        result = data[rowKey].row;
                    }
                    rowKey = keys.shift();
                }
            }
            return result;
        },

        /**
         * Same thing as toJSON, except it goes through relations and looks for an
         * 'omitFromSave' boolean property on the relation object. If true, this
         * field will not be added to the output. Additionally, looks
         * at a relation's 'saveJSONFields' property, if present, and grabs only
         * those objects for the output.
         * @private
         * @memberOf SoaModel#
         * @returns {object}
         */
        _omitToJSON : function () {
            return omitToJSON.call(this, this);
        },

        /**
         * @description Returns true if all fields are present and holding
         * truthy values. If a field can legitimately hold `false` or 0 or ''
         * don't use this function to check it's presence.
         * @param {Array} fields An array of field names to test
         * @returns {boolean}
         */
        hasTruthyFields: function (fields) {
            return _.every(fields, function (field) {
                return this.get(field) || false;
            }, this);
        }
    });

    /**
     * Create a basic relation from strings.
     * A string is converted into a one-to-one
     * relation and uses the 'SoaModel' as
     * the relatedModel.
     * If one of the relations passed is an
     * object, that object will be used.
     * @memberOf SoaModel
     * @param rels
     * @returns {Array}
     */
    SoaModel.createRelations = function (rels) {
        var i = 0, len = rels.length, newRels = [];
        for (i; i < len; i++) {
            newRels[i] = createRel(rels[i]);
        }
        return newRels;
    };

    createRel = function (rel) {
        var key, val, res = {}, isStd = false;
        if (_.isObject(rel)) {
            for (key in rel) {
                if (rel.hasOwnProperty(key)) {
                    val = rel[key];
                    if (_.isArray(val)) {
                        res.key = key;
                        res.relatedModel = SoaModel.extend({
                            relations: SoaModel.createRelations(val)
                        });
                        break;
                    }
                    isStd = true;
                    break;
                }
            }
            if (isStd) { return rel; }
        }

        res.type = Backbone.One;
        if (typeof rel === 'string') {
            res.key = rel;
            res.relatedModel = SoaModel;
        }
        return res;
    };
    omitToJSON = function (model) {
        var key, attr, omitLen,
            i = -1,
            relations = model.relations,
            len = relations ? relations.length : 0,
            omitKeys = [],
            attrs = model.attributes,
            pickFields = {},
            fieldJson = {},
            json = {};
        while (++i < len) {
            if (relations[i].omitFromSave) {
                omitKeys.push(relations[i].key);
            }
            if (relations[i].saveJSONFields) {
                pickFields[relations[i].key] = relations[i].saveJSONFields;
            }
        }
        omitLen = omitKeys.length;
        for (key in attrs) {
            if (attrs.hasOwnProperty(key)) {
                attr = attrs[key];
                if (typeof attr === 'object' && attr !== null) {
                    if (!omitLen || _.indexOf(omitKeys, key) === -1) {
                        if (attr instanceof Backbone.AssociatedModel) {
                            fieldJson = omitToJSON.call(this, attr);
                            json[key] = (pickFields[key]) ? _.pick(fieldJson, pickFields[key]) : fieldJson;
                        } else if (attr instanceof Backbone.Collection) {
                            json[key] = [];
                            i = -1;
                            len = attr.models.length;
                            while (++i < len) {
                                fieldJson = omitToJSON.call(this, attr.models[i]);
                                json[key].push(pickFields[key] ? _.pick(fieldJson, pickFields[key]) : fieldJson);
                            }
                        } else {
                            json[key] = _.clone(attr);
                        }
                    }
                } else {
                    json[key] = attr;
                }
            }
        }
        return json;
    };

}));



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/SoaModel.js
// module id = 2
// module chunks = 63